import ImageIcon from "@mui/icons-material/Image";
import {
    Box,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { S3Service } from "../../../Utilities/S3Service";
import { monthFormatter } from "../Bill/SingleBill";

export const ShowReadingImage = ({ reading }: any) => {
    const [content, setContent] = useState<any>(null);
    const [open, setOpen] = useState(false);

    const getReadingImage = async () => {
        setContent(
            <Typography p={2} textAlign="center">
                <CircularProgress />
            </Typography>
        );

        const readingKey = `readings/${reading.id}`;
        const [data, err] = await S3Service.getS3ByKey(readingKey);

        if (!data || err) {
            setContent(
                <Typography p={2} textAlign="center" color="gray">
                    No image uploaded
                </Typography>
            );
            return;
        }

        try {
            const response = await fetch(data.url);
            const blob = await response.blob();

            if (response.status === 200) {
                setContent(
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            p: 2,
                        }}
                    >
                        <img
                            src={URL.createObjectURL(blob)}
                            alt="reading"
                            style={{
                                aspectRatio: "4/3",
                                maxHeight: "300px",
                                width: "auto",
                                borderRadius: "6px",
                            }}
                        />
                    </Box>
                );
            } else {
                throw new Error("Failed to fetch image");
            }
        } catch {
            setContent(
                <Typography p={2} textAlign="center" color="gray">
                    No image uploaded
                </Typography>
            );
        }
    };

    useEffect(() => {
        if (open) {
            getReadingImage();
        }
    }, [open]);

    return (
        <Box>
            <IconButton onClick={() => setOpen(true)}>
                <ImageIcon />
            </IconButton>

            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle textAlign="center">
                    {reading.meter.meterNo +
                        " - " +
                        monthFormatter.format(
                            new Date(
                                reading.year ?? 0,
                                (reading.month ?? 1) - 1,
                                1
                            )
                        )}
                </DialogTitle>

                <DialogContent dividers> {content}</DialogContent>
            </Dialog>
        </Box>
    );
};
